/**
 * The contract between the three doors that can discover an unverified
 * account (sign-in, sign-up, forgot-password) and the /verify page they send
 * it to. The strings live here once so the pairs cannot drift apart.
 */
export const VERIFY_REASON_UNVERIFIED = 'unverified';

// next-auth carries a CredentialsSignin subclass's `code` to the client as
// signIn(...).code and also puts it in a URL, so it names the state, never
// the account.
export const SIGNIN_CODE_UNVERIFIED_SENT = 'unverified_code_sent';
export const SIGNIN_CODE_UNVERIFIED_NOT_SENT = 'unverified_code_not_sent';

export function unverifiedSigninCode(codeSent: boolean): string {
  return codeSent
    ? SIGNIN_CODE_UNVERIFIED_SENT
    : SIGNIN_CODE_UNVERIFIED_NOT_SENT;
}

export function readUnverifiedSigninCode(
  code: string | undefined
): { codeSent: boolean } | null {
  if (code === SIGNIN_CODE_UNVERIFIED_SENT) {
    return { codeSent: true };
  }
  if (code === SIGNIN_CODE_UNVERIFIED_NOT_SENT) {
    return { codeSent: false };
  }
  return null;
}

export interface VerifyDestination {
  /** Set when the account already existed and was found unverified. */
  reason?: typeof VERIFY_REASON_UNVERIFIED;
  /** Whether Cognito actually sent a code on the way here. */
  codeSent?: boolean;
  /** The door that found the account; sign-up owes a word about the password. */
  via?: 'signup';
}

export function verifyPath({ reason, codeSent, via }: VerifyDestination): string {
  const params = new URLSearchParams();
  if (reason) {
    params.set('reason', reason);
  }
  if (codeSent !== undefined) {
    params.set('sent', codeSent ? '1' : '0');
  }
  if (via) {
    params.set('via', via);
  }
  const query = params.toString();
  return query ? `/verify?${query}` : '/verify';
}
